import {
	ChangeDetectionStrategy,
	Component,
	input,
	InputSignal,
	OnDestroy,
	signal,
	WritableSignal,
} from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { TuiDropdown } from '@taiga-ui/core'
import { OptionOrderInterface } from '@modules/options-module/orders/interfaces/option-order.interface'
import { InfoOptionsOrderComponent } from '@shared/components/trading/orders/orders-options/tables/options/actions/info-options-order/info-options-order.component'
import { DropdownVariantEnum } from '@shared/enums/dropdown-variant.enum'
import { Subject } from 'rxjs'
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@Component({
	selector: 'app-options-executed-orders-actions',
	templateUrl: './options-executed-orders-actions.component.html',
	styleUrl: './options-executed-orders-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslatePipe, TuiDropdown, InfoOptionsOrderComponent, ClickOutsideDirective, ButtonComponent],
})
export class OptionsExecutedOrdersActionsComponent implements OnDestroy {
	protected readonly dropdownVariantEnum: typeof DropdownVariantEnum = DropdownVariantEnum

	public option: InputSignal<OptionOrderInterface | null> = input<OptionOrderInterface | null>(null)

	private _destroy$: Subject<void> = new Subject<void>()

	protected openedDropdown: WritableSignal<DropdownVariantEnum | null> = signal(null)

	protected toggleDropdown(dropdown: DropdownVariantEnum | null): void {
		if (this.openedDropdown() === dropdown) {
			this.openedDropdown.set(null)
		} else {
			this.openedDropdown.set(dropdown)
		}
	}

	protected onClickOutside(): void {
		this.openedDropdown.set(null)
	}

	ngOnDestroy(): void {
		this._destroy$.next()
		this._destroy$.complete()
	}
}
